// called in both the classic and block editor

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import {SENTRY_DSN, KEEN_PROJECT_ID, KEEN_KEY} from './utility';
import KeenTracking from 'keen-tracking';
import './global.css';

// global object
if(!_.isObject(window.AP)){
  window.AP = {};
}

export default function initializeTracking(){
	// Sentry Integration: 
	Sentry.init({
	  dsn: SENTRY_DSN,
	  integrations: [new Integrations.BrowserTracing()],
	  tracesSampleRate: 1.0,
	  attachStacktrace: true
	});

	// Analytics tracking
	const keenClient = new KeenTracking({
	  projectId: KEEN_PROJECT_ID,
	  writeKey: KEEN_KEY
	});
	window.AP.tanalytics = {
	  track: (eventName, meta) => {
	    if(AP.currentUser && AP.currentUser.email){
	      meta = Object.assign({}, meta, AP.currentUser);
	    }
	    keenClient.recordEvent(eventName, meta);
	  },
	  identify: (userMetadata) => {
	    AP.currentUser = userMetadata;
	  }
	}
}